import { render, staticRenderFns } from "./administrativeDocumentAddView.vue?vue&type=template&id=961ad5d0&scoped=true"
import script from "./administrativeDocumentAddView.vue?vue&type=script&lang=js"
export * from "./administrativeDocumentAddView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ad5d0",
  null
  
)

export default component.exports